export const apiBaseUri = () => {
  if (window.location.href.includes(8080) || window.location.href.includes("loca.lt")) {
    return "http://0.0.0.0:5000";
  }
  return process.env.PREACT_APP_SERVER_URL;
};
